export default "__VITE_ASSET__gVtxbn6m__"